export const environment = {
  app: "BUB",
  version: "BUB 26122022",
  production: false,
  URL_GLOBAL: "https://bub-dev.egl-cloud.com/bub",
  URL_GLOBAL_REPORTES: "https://bub-dev.egl-cloud.com/eg-bub-reportes-service",
  uris: {
    comunes: {
      login: "https://bub-dev.egl-cloud.com/eg-bub-vc-seguridad-service/saml/login",
      usuario:"https://bub-dev.egl-cloud.com/eg-bub-vc-seguridad-service/usuario",
      logout: "https://bub-dev.egl-cloud.com/eg-bub-vc-seguridad-service/saml/logout",
      borrarPerfilamiento: "https://bub-dev.egl-cloud.com/eg-bub-perfilamiento-service/perfilamiento/clear/cache/usuario",
      
    }
  }
};
